import '../ContactSection/Styles.css';
import React, {useState} from 'react';
import { Link } from 'react-router-dom';  // Import Link from react-router-dom


const ContactSection = () => {
    // eslint-disable-next-line no-unused-vars
    const [isOpen, setIsOpen] = useState(false);
    // Close the navbar when a link is clicked
    const handleLinkClick = (url) => {
            setIsOpen(false); // Close the navbar
            window.location.href = url; // Force navigation to the specific URL
        };
  return (
    <>
      <div className='contactUsSection'>
            <div className='logoMindfulBreaksSection'>
                <img src='/images/MindfulBreaks_Logo_RGB_with_tagline_White.png' className='logoContactSection' alt='logo of mindful breaks' />
            </div>
            <div className='paginasDetails'>
                <h3 className='contactUsTitle'>MENU</h3>
                <Link onClick={() => handleLinkClick('/')}>Home</Link>
                <Link onClick={() => handleLinkClick('/overmij')}>Over Mij</Link>
                <Link onClick={() => handleLinkClick('/aanbod')}>Aanbod</Link>
                <Link onClick={() => handleLinkClick('/privelessen')}>Privélessen</Link>
                <Link onClick={() => handleLinkClick('/yogavoorbedrijven')}>Yoga voor bedrijven</Link>
                <Link onClick={() => handleLinkClick('/tarieven')}>Tarieven</Link>
                <Link onClick={() => handleLinkClick('/woordenboek')}>Woordenboek</Link>
                <Link onClick={() => handleLinkClick('/blog')}>Blog</Link>
                <Link onClick={() => handleLinkClick('/watisyoga')}>Wat is yoga?</Link>
                <Link onClick={() => handleLinkClick('/contact')}>Contact</Link>
            </div>
            <div className='contactUsDetails'>
                <div className='contactUsDetailsOne'>
                    <h3 className='contactUsTitle'>CONTACT</h3>
                    <a href="tel:+32470867958">Telefoon: +32 (0) 470 86 79 58</a>
                    <a href="mailto:mindfulbreaksbe@gmail.com">E-mail: mindfulbreaksbe@gmail.com</a>
                </div>
                <div className='contactUsDetailsTwo'>
                    <h3 className='contactUsTitle'>SOCIAL MEDIA</h3>
                    <a href='https://www.instagram.com/mindful_breaks_be/' target='_blank' rel='noreferrer'>Instagram</a>
                    <a href='https://www.facebook.com/people/Mindful-Breaks/100085196955233/' target='_blank' rel='noreferrer'>Facebook</a>
                    <a href='https://wa.me/32470867958/' target='_blank' rel='noreferrer'>WhatsApp</a>
                </div>
            </div>
        </div>
    </>
  )
}

export default ContactSection;
